import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPassword } from '../../../actions/userProfileActions';
import IPageViewModel from '../../../interfaces/umbracoNodes/pageViewModel';
import Button from '../../base/button/button';
import FormikFieldWrapper from '../../base/forms/formikFieldWrapper';
import { StyledErrorMessage } from '../../base/forms/formikFieldWrapper.styles';
import { StyledFormikField } from '../../base/forms/input';
import { Columns } from '../../base/grid';
import { H1, P } from '../../base/typography';
import { forgotPasswordSchema, frogotPasswordInitialValues } from './forgotPassword.schema';
import * as StyledForgotPassword from './forgotPassword.styles';

interface Props {
	page: IPageViewModel;
}

const ForgotPassword: FC<Props> = ({ page }) => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const {
		forgotPasswordSuccess,
		forgotPasswordError,
		forgotPasswordErrorMessage,
		forgotPasswordLoading,
	}: {
		forgotPasswordSuccess: boolean;
		forgotPasswordError: boolean;
		forgotPasswordErrorMessage: string;
		forgotPasswordLoading: boolean;
	} = useSelector(({ userProfileReducer }) => userProfileReducer);

	return (
		<Columns>
			<StyledForgotPassword.FormWrapper>
				<H1>{page.Name}</H1>
				<P>{t('page-login.forgot-password-instructions')}</P>

				{forgotPasswordSuccess ? (
					<P>{t('success')}</P>
				) : (
					<>
						{forgotPasswordError && <StyledErrorMessage>{forgotPasswordErrorMessage}</StyledErrorMessage>}
						<Formik
							initialValues={frogotPasswordInitialValues}
							validationSchema={forgotPasswordSchema}
							onSubmit={values => {
								dispatch(forgotPassword(values.email));
							}}>
							{() => (
								<Form>
									<FormikFieldWrapper label={t('email')} name="email" languageComponent="myShipments">
										<StyledFormikField
											type="text"
											id="email"
											name="email"
											placeholder={t('email')}
										/>
									</FormikFieldWrapper>
									<Button primary mobileBlock type="submit" isLoading={forgotPasswordLoading}>
										{t('send')}
									</Button>
								</Form>
							)}
						</Formik>
					</>
				)}
			</StyledForgotPassword.FormWrapper>
			<StyledForgotPassword.ImageWrapper>
				<StyledForgotPassword.Image image={page?.Values?.PagePicture?.Src} />
			</StyledForgotPassword.ImageWrapper>
		</Columns>
	);
};

export default ForgotPassword;
